import { z } from 'zod';

export const GcrFormSchema = z.object({
  filePublicUrl: z.string().min(1, 'GSR file is required'),
  name: z
    .string()
    .min(3, 'Gcr name must be at least 3 characters long')
    .max(100, 'Gcr name cannot exceed 100 characters'),
  printerId: z.string().min(1, 'Printer is required'),
  typeId: z.string().min(1, 'Model type is required'),
  sizeId: z.string().min(1, 'Size is required'),
  colorId: z.string().min(1, 'Color is required'),
});
